<template>
  <section class="app-main">
    <transition name="fade" mode="out-in">
      <keep-alive :include="aliveTabs">
      <router-view></router-view>
      </keep-alive>
    </transition>
  </section>
</template>

<script>
export default {
  name: 'AppMain',
  data() {
    return {
      aliveTabs: ''
    }
  },
  computed: {
    // key() {
    //   return this.$route.name !== undefined ? this.$route.name + +new Date() : this.$route + +new Date()
    // }
  },
  watch: {
    $route(to, from) {
      if (to.name === 'dailyTasks' || to.name === 'dailyTasksDetail') {
        this.aliveTabs = ['dailyTasks']
        return
      }
      if (to.name === 'lookingBackBusiness' || to.name === 'lookingBackBusinessDetail') {
        this.aliveTabs = ['lookingBackBusiness']
        return
      }
      this.aliveTabs = []
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/layout/components/AppMain.vue